export enum OAuthProviders {
  APPLE = 'Apple',
  GOOGLE = 'Google',
}

export interface RegistrationConfig {
  oauthProviders: Array<OAuthProviders>;
  oauthProvidersEnabled: Boolean;
  recaptchaEnabled: Boolean;
}

export interface RegistrationConfigResponse {
  status: Number;
  data: RegistrationConfig | null;
  error?: string;
}

export interface SocialLoginMessageData {
  action: string;
  status: string;
  tracking_id: string;
  cookie: string;
}
